export var Feature = 'Feature';
export var FeatureCollection = 'FeatureCollection';
export var MultiPoint = 'MultiPoint';



//////////////////
// WEBPACK FOOTER
// ./~/vega-geo/src/constants.js
// module id = 795
// module chunks = 0